import styled, { css, createGlobalStyle } from 'styled-components';
import { colors } from '../../tokens/samolet/colors.js';
import { Box as Box$1 } from '../../grid/Box/styled.js';

const modalCss = css `
  .tend-ui-modal-confirm {
    &&& {
      .tend-ui-modal-close {
        width: 22px;
        height: 22px;
        top: 32px;
        inset-inline-end: 32px;
        border-radius: 50%;
        background-color: ${colors.gray50};
      }
    }

    .tend-ui-modal-confirm-btns {
      margin-top: 24px;
    }
    &.tend-ui-modal-confirm-image-cover {
      .tend-ui-modal-content {
        padding: 0px;
      }
      .tend-ui-modal-confirm-paragraph {
        padding: 0 32px;
      }
    }

    &.tend-ui-modal-confirm-confirm {
      .tend-ui-modal-confirm-body {
        flex-direction: column;
      }
    }
    &.tend-ui-modal-confirm-info,
    &.tend-ui-modal-confirm-success,
    &.tend-ui-modal-confirm-warning,
    &.tend-ui-modal-confirm-error {
      .tend-ui-modal-confirm-body {
        flex-direction: column;
        align-items: center;

        & > .anticon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          margin-inline-end: 0px;
          font-size: 48px;
          border-radius: 50%;
          width: 80px;
          height: 80px;
        }

        & > .anticon-info-circle {
          background-color: ${colors.blue100};
        }
        & > .anticon-check-circle {
          background-color: ${colors.green100};
        }
        & > .anticon-exclamation-circle {
          background-color: ${colors.gold200};
        }
        & > .anticon-close-circle {
          background-color: ${colors.red100};
        }

        .tend-ui-modal-confirm-content {
          font-family: Museo Sans Cyrl;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
      }

      .tend-ui-modal-confirm-paragraph {
        text-align: center;
      }
    }
  }
`;
const Styles = createGlobalStyle `${modalCss}`;
const Img = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const ImageContainer = styled.div `
  height: 100%;
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: ${props => (props.$layout === 'contain' ? '8px' : '24px 24px 0 0')};
`;
const Box = styled(Box$1) `
  font-family: Museo Sans Cyrl;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export { Box, ImageContainer, Img, Styles };
//# sourceMappingURL=styled.js.map
